import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
import { Flex } from '@magnetic/flex';
import { pxToVh, pxToVw } from '../../../../common/util';
import { useTranslation } from 'react-i18next';
const Container = styled(Flex) `
  background-color: #272a2f;
  background: #272a2f;
  height: ${(props) => pxToVh(props.height)};
  max-height: ${(props) => pxToVh(props.height)};
  width: ${(props) => pxToVw(props.width)};
  max-width: ${(props) => pxToVw(props.width)};
  border-radius: ${(props) => props.size === 'xs' || 'xsm' ? pxToVw(12) : pxToVw(22.4)};
  padding: 0.2vw;
  overflow: hidden;
  box-sizing: border-box;
`;
const Text = styled.span `
  font-family: 'CiscoSansRegular';
  font-size: ${(props) => FONT_SIZE[props.size]};
  font-size: ${(props) => pxToVw(FONT_SIZE[props.size])};
`;
const TitleText = styled(Text) `
  line-height: ${(props) => window.innerHeight > window.innerWidth
    ? pxToVh(PORTRAIT_TITLE_FONT_LINE_HEIGHT[props.size])
    : pxToVh(TITLE_FONT_LINE_HEIGHT[props.size])};
  margin-bottom: 0.1vh;
  white-space: nowrap;
`;
const StatusText = styled(Text) `
  color: ${(props) => (props.color ? props.color : '#00BCEB')};
  margin-top: -10px;
`;
export const ImageContainer = styled.div `
  font-family: 'CiscoSansRegular';
  font-size: 20px;
  line-height: 2vw;
  height: 2vw;
  word-wrap: break-word;
`;
const STATUS_COLOR_MAPPING = {
    excellent: '#82CF5F',
    'very good': '#82CF5F',
    good: '#59A83D',
    fair: '#FFEC42',
    poor: '#FEAF1D',
    inadequate: '#FF5A36',
    number: '#00BCEB',
};
const TELEMETRY_IMG_MAPPING = {
    excellent: require('../../../../assets/images/telemetry/excellent.png'),
    'very good': require('../../../../assets/images/telemetry/excellent.png'),
    good: require('../../../../assets/images/telemetry/good.png'),
    fair: require('../../../../assets/images/telemetry/fair.png'),
    poor: require('../../../../assets/images/telemetry/poor.png'),
    inadequate: require('../../../../assets/images/telemetry/inadequate.png'),
    10: require('../../../../assets/images/telemetry/10.png'),
    20: require('../../../../assets/images/telemetry/20.png'),
    30: require('../../../../assets/images/telemetry/30.png'),
    40: require('../../../../assets/images/telemetry/40.png'),
    50: require('../../../../assets/images/telemetry/50.png'),
    60: require('../../../../assets/images/telemetry/60.png'),
    70: require('../../../../assets/images/telemetry/70.png'),
    80: require('../../../../assets/images/telemetry/80.png'),
    90: require('../../../../assets/images/telemetry/90.png'),
    100: require('../../../../assets/images/telemetry/100.png'),
    'very low': require('../../../../assets/images/telemetry/20.png'),
    low: require('../../../../assets/images/telemetry/40.png'),
    busy: require('../../../../assets/images/telemetry/60.png'),
    'very busy': require('../../../../assets/images/telemetry/80.png'),
    crowded: require('../../../../assets/images/telemetry/100.png'),
    // added noise_prefix because 'good' already exists in this map
    noise_good: require('../../../../assets/images/telemetry/20.png'),
    noise_quiet: require('../../../../assets/images/telemetry/40.png'),
    noise_moderate: require('../../../../assets/images/telemetry/60.png'),
    noise_loud: require('../../../../assets/images/telemetry/80.png'),
    'noise_very loud': require('../../../../assets/images/telemetry/100.png'),
};
const TELEMETRY_IMG_MAPPING_FOR_TEMPERATURE = {
    0: require('../../../../assets/images/telemetry/10.png'),
    10: require('../../../../assets/images/telemetry/20.png'),
    20: require('../../../../assets/images/telemetry/50.png'),
    30: require('../../../../assets/images/telemetry/70.png'),
    40: require('../../../../assets/images/telemetry/70.png'),
    50: require('../../../../assets/images/telemetry/80.png'),
    60: require('../../../../assets/images/telemetry/80.png'),
    70: require('../../../../assets/images/telemetry/80.png'),
    80: require('../../../../assets/images/telemetry/90.png'),
    90: require('../../../../assets/images/telemetry/90.png'),
    100: require('../../../../assets/images/telemetry/100.png'),
};
const TELEMETRY_ICON_MAPPING = {
    'Avg. Temperature': require('../../../../assets/images/telemetry/temperature_icon.svg'),
    'Avg. Humidity': require('../../../../assets/images/telemetry/humidity_icon.svg'),
    'Floor Occupancy': require('../../../../assets/images/telemetry/floor_occupancy_icon.svg'),
    'Ambient Noise': require('../../../../assets/images/telemetry/ambient_noise_icon.svg'),
};
const SIZE_MAP = {
    xs: 0.34,
    xsm: 0.42,
    sm: 0.7,
    md: 1,
    lg: 1.3,
    xl: 1.6,
};
const PORTRAIT_SIZE_MAP = {
    sm: {
        sm1: '10vw',
        sm5: '10vw',
        sm2: '2vw',
        sm3: '14vw',
        sm4: '16vw',
    },
    xsm: {
        sm1: '5.2vw',
        sm5: '4.12vw',
        sm2: '1vw',
        sm3: '10vw',
        sm4: '9.2vw',
    },
    xs: {
        sm1: '3.2vw',
        sm5: '3vw',
        sm2: '0.8vw',
        sm3: '6.8vw',
        sm4: '6.2vw',
    },
};
const FONT_SIZE = {
    xs: 10,
    xsm: 12,
    sm: 19.6,
    md: 27.07,
    lg: 33,
    xl: 38,
};
const TITLE_FONT_LINE_HEIGHT = {
    xs: 20,
    xsm: 28,
    sm: 38.07,
    md: 52.58,
    lg: 52.58,
    xl: 52.58,
};
const PORTRAIT_TITLE_FONT_LINE_HEIGHT = {
    xs: 8,
    xsm: 28,
    sm: 38.07,
};
function convertToCelsius(val) {
    return ((val - 32) * 5) / 9;
}
function getTelemetryImage(widgetType, statusValue, size, TELEMETRY_WIDGETS) {
    if (widgetType === TELEMETRY_WIDGETS.TEMPERATURE ||
        widgetType === TELEMETRY_WIDGETS.HUMIDITY ||
        widgetType === TELEMETRY_WIDGETS.OCCUPANCY ||
        widgetType === TELEMETRY_WIDGETS.AMBIENT_NOISE) {
        return (_jsx("div", Object.assign({ style: {
                backgroundImage: `url(${widgetType === TELEMETRY_WIDGETS.TEMPERATURE ? TELEMETRY_IMG_MAPPING_FOR_TEMPERATURE[statusValue] : TELEMETRY_IMG_MAPPING[statusValue]})`,
                backgroundSize: 'cover',
                width: `${window.innerWidth > window.innerHeight ? pxToVw(100 * SIZE_MAP[size]) : PORTRAIT_SIZE_MAP[size].sm1}`,
                height: `${window.innerWidth > window.innerHeight ? pxToVh(100 * SIZE_MAP[size]) : PORTRAIT_SIZE_MAP[size].sm5}`,
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
                marginBottom: `${pxToVh(10)}`,
            } }, { children: _jsx("img", { src: TELEMETRY_ICON_MAPPING[widgetType], style: {
                    width: `${window.innerWidth > window.innerHeight ? pxToVw((100 * SIZE_MAP[size]) / 3) : PORTRAIT_SIZE_MAP[size].sm2}`,
                    height: `${window.innerWidth > window.innerHeight ? pxToVh((100 * SIZE_MAP[size]) / 3) : PORTRAIT_SIZE_MAP[size].sm2}`,
                    maxHeight: `${window.innerWidth > window.innerHeight ? pxToVw((100 * SIZE_MAP[size]) / 3) : PORTRAIT_SIZE_MAP[size].sm2}`,
                    maxWidth: `${window.innerWidth > window.innerHeight ? pxToVw((100 * SIZE_MAP[size]) / 3) : PORTRAIT_SIZE_MAP[size].sm2}`,
                } }) })));
    }
    else {
        return (_jsx("div", { style: {
                backgroundImage: `url(${TELEMETRY_IMG_MAPPING[statusValue]})`,
                backgroundSize: 'cover',
                width: `${window.innerWidth > window.innerHeight ? pxToVw(100 * SIZE_MAP[size]) : PORTRAIT_SIZE_MAP[size].sm1}`,
                height: `${window.innerWidth > window.innerHeight ? pxToVh(100 * SIZE_MAP[size]) : PORTRAIT_SIZE_MAP[size].sm5}`,
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
                marginBottom: `${pxToVh(10)}`,
            } }));
    }
}
export function TelemetryWidget({ type, status, size = 'md', }) {
    function roundToNearestTen(num) {
        return Math.round(num / 10) * 10;
    }
    const { t } = useTranslation();
    const TELEMETRY_WIDGETS = {
        OCCUPANCY: 'Floor Occupancy',
        IAQ: 'Indoor Air Quality',
        CO2: 'CO2 Level',
        TEMPERATURE: 'Avg. Temperature',
        HUMIDITY: 'Avg. Humidity',
        AMBIENT_NOISE: 'Ambient Noise',
    };
    const localizedWidgetNames = {
        OCCUPANCY: t('common.floor-occupancy'),
        IAQ: t('common.iaq'),
        CO2: t('common.co2'),
        TEMPERATURE: t('common.temperature'),
        HUMIDITY: t('common.humidity'),
        AMBIENT_NOISE: t('common.ambient-noise'),
    };
    const widgetType = TELEMETRY_WIDGETS[type];
    let statusColor = STATUS_COLOR_MAPPING[status.toLowerCase()];
    let statusValue = status.toLowerCase();
    if (widgetType === TELEMETRY_WIDGETS.TEMPERATURE ||
        widgetType === TELEMETRY_WIDGETS.HUMIDITY) {
        let statusVCalc = status.substring(0, 2);
        const unit = status.split('°')[1];
        if (widgetType === TELEMETRY_WIDGETS.TEMPERATURE && unit === 'F') {
            statusVCalc = convertToCelsius(statusVCalc).toString();
        }
        statusValue = roundToNearestTen(parseInt(statusVCalc)).toString();
        statusColor = STATUS_COLOR_MAPPING['number'];
    }
    return (_jsxs(Container, Object.assign({ direction: "verticle", gap: 4, height: window.innerHeight > window.innerWidth
            ? PORTRAIT_SIZE_MAP[size].sm3
            : 200 * SIZE_MAP[size], width: window.innerHeight > window.innerWidth
            ? PORTRAIT_SIZE_MAP[size].sm4
            : 280 * SIZE_MAP[size], align: localizedWidgetNames[type].length > 18 ? 'left' : 'center', justify: localizedWidgetNames[type].length > 18 ? 'flex-start' : 'center', size: size, id: `telemetry-${widgetType}`, style: { marginRight: '0.24vw' } }, { children: [_jsx(TitleText, Object.assign({ size: size }, { children: localizedWidgetNames[type] })), _jsxs("div", Object.assign({ style: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '0.1vw',
                    flexDirection: 'column',
                    marginTop: '-0.4vw',
                } }, { children: [getTelemetryImage(widgetType, statusValue, size, TELEMETRY_WIDGETS), _jsx(StatusText, Object.assign({ size: size, color: statusColor }, { children: status.startsWith('noise_')
                            ? t(`common.${status.substring(6).toLowerCase().replace(/ /g, '-')}`)
                            : widgetType !== TELEMETRY_WIDGETS.TEMPERATURE &&
                                widgetType !== TELEMETRY_WIDGETS.HUMIDITY
                                ? t(`common.${status.toLowerCase().replace(/ /g, '-')}`)
                                : status }))] }))] })));
}
